import gql from "graphql-tag";

const CHANGE_PASSWORD = gql`
  mutation changePassword($userId: ID!, $newPassword: String!) {
    changePassword(userId: $userId, newPassword: $newPassword)
  }
`;

export default CHANGE_PASSWORD;
